/**
 * T062/T091: Prompts List Route
 * Route for viewing prompts list with search params validation
 */

import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PromptsListPage } from '@/pages/prompts/prompts-list'

const promptsSearchSchema = z.object({
  q: z.string().optional(),
  categoryId: z.string().optional(),
  tagIds: z.string().optional(), // Comma-separated string
  page: z.coerce.number().min(1).optional().default(1),
})

export type PromptsSearch = z.infer<typeof promptsSearchSchema>

export const Route = createFileRoute('/_authenticated/prompts/')({
  component: PromptsListPage,
  validateSearch: promptsSearchSchema,
})
